import { render } from "./TheHeader.vue?vue&type=template&id=e90a6228&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=e90a6228&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90a6228"]])

export default __exports__